import React, { useState, useEffect } from "react";
import "../CSS/TasksPage.css";
import {
  Navbar,
  Button,
  AddTaskForm,
  TaskCard,
} from "../components/indexComponents";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

function TasksPage() {
  const [tasks, setTasks] = useState([{}, {}, {}]);
  const [addTaskForm, setAddTaskForm] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const buttonNavbar = [{ route: "/dashboard", text: "Dashboard" }];

  useEffect(() => {
    fetchTasks();
  }, []);

  const refreshTasks = () => {
    fetchTasks();
  };

  const fetchTasks = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/my-tasks`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!response.ok) {
        setIsLoading(false);
        throw new Error("Failed to fetch tasks");
      }

      const data = await response.json();
      console.log(data);
      setTasks(data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching tasks:", error);
    }
  };
  return (
    <div id="TasksPage" className="page-frame">
      <Navbar buttonNavbar={buttonNavbar} />
      <div className="TasksPage-frame page-content">
        <Button icon={faArrowLeft} route={`/dashboard`} className="back-btn" />

        <h1>Tâches actives</h1>
        {/* {!isLoading ?  */}
        <>
          {addTaskForm ? (
            ""
          ) : (
            <Button
              className="add-task-btn"
              text="Ajouter une tache"
              onClick={(e) => setAddTaskForm(true)}
            />
          )}

          {addTaskForm ? (
            <AddTaskForm
              cancelBtnOnClick={(e) => setAddTaskForm(false)}
              onTaskAdded={refreshTasks}
            />
          ) : (
            <div></div>
          )}

          <div className="tache-container">
            {tasks.map((task) => (
              <TaskCard
                key={task.id}
                task={task}
                refreshTasks={refreshTasks}
                isTeam={false}
                isLoading={isLoading}
              />
            ))}
          </div>
        </>
        {/* :
          <>
            <div>
              <h1 className='loading-msg'>Chargement des tâches...</h1>
            </div>
          </>
        } */}
      </div>
    </div>
  );
}

export default TasksPage;
